export default {
  paragraph1: {
    id: 'cart_unavailable_bouygues_cancel_oos_description1',
    defaultMessage:
      'We’re unable to cancel your order at this time. To make changes to your device order or mobile plan, talk with a Bouygues representative.',
  },
  paragraph2title: {
    id: 'cart_unavailable_bouygues_cancel_oos_description2_title',
    defaultMessage: 'Not in store?',
  },
  paragraph2: {
    id: 'cart_unavailable_bouygues_cancel_oos_description2',
    defaultMessage:
      'Wait for your link to expire with the timer above, then contact Bouygues Customer Care for next steps.',
  },
}
